import React from 'react';
import noChildren from './../../../../assets/images/svg/002-nochildren.svg';
import children from './../../../../assets/images/svg/002-children.svg';
import homechildren from './../../../../assets/images/svg/002-homechildren.svg';
import { ModalFamilyEnv } from './modals/modalFamilyEnv';
import differenceInYears from "date-fns/differenceInYears";

export const FamilyEnvironment = ({deathDeclaration, userId, isLoading}) => {
    const today = new Date();
    let minorChildren = deathDeclaration.childrens.filter(c => differenceInYears(today, new Date(c.birthDate)) < 18);
    let youngAdults = deathDeclaration.childrens.filter(c => differenceInYears(today, new Date(c.birthDate)) >= 18 && differenceInYears(today, new Date(c.birthDate)) < 21);
    let handicapedChildren = deathDeclaration.childrens.filter(c => c.isHandicaped === true);

    return (
        <section className="card mb-sm">
            <div className="card-header pb-0">
                <div className="grid grid-sm-2 align-items-center">
                    <h2 className="h4 text-uppercase text-secondary font-weight-bolder my-auto">Environnement familial et privé</h2>
                    <div className="grid grid-2 ml-sm-auto align-items-center">
                        <button type="button" data-toggle="modal" data-target="#familyModalEnv" className="btn btn-icon p-1 align-middle o-80 o-100--hover mx-auto"><i className="eva eva-edit-2-outline align-middle fs-lead"></i></button>
                        <div className="custom-control custom-switch mx-auto">
                            <input type="checkbox" className="custom-control-input" id="familyEnvSwitchCheckDefault" required="required"  defaultChecked={deathDeclaration.onBoardingStep > 3} />
                            <label className="custom-control-label" htmlFor="familyEnvSwitchCheckDefault">Valider</label>
                        </div>
                    </div>
                </div>
                <hr className="mb-0" />
            </div>
            <div className="card-body grid grid-sm-2 grid-lg-3 grid-xl-5 gy-3">
                <div className="flex-row align-items-center">
                    <img className="img-fluid mr-3 h-4" src={children} alt="maison" />
                    <div className="my-auto">
                        <p className="h6 text-uppercase font-weight-bold my-auto o-70">enfants</p>
                        <p className="h3 text-uppercase font-weight-bold my-auto">{deathDeclaration.childrens.length}</p>
                    </div>
                </div>
                <div className="flex-row align-items-center">
                    <img className="img-fluid mr-3 h-4" src={noChildren} alt="-18" />
                    <div className="my-auto">
                        <p className="h6 text-uppercase font-weight-bold my-auto o-40"> &lt; 18 ans</p>
                        <p className="h6 text-uppercase font-weight-bold my-auto">{minorChildren.length} mineur(s)</p>
                    </div>
                </div>
                <div className="flex-row align-items-center">
                    <img className="img-fluid mr-3 h-4" src={noChildren} alt="-18" />
                    <div className="my-auto">
                        <p className="h6 text-uppercase font-weight-bold my-auto o-40"> 18 à 21 ans</p>
                        <p className="h6 text-uppercase font-weight-bold my-auto">{youngAdults.length} majeur(s)</p>
                    </div>
                </div>
                <div className="flex-row align-items-center">
                    <img className="img-fluid mr-3 h-4" src={noChildren} alt="+21" />
                    <div className="my-auto">
                        <p className="h6 text-uppercase font-weight-bold my-auto o-40"> &gt; 21 ans</p>
                        <p className="h6 text-uppercase font-weight-bold my-auto">{deathDeclaration.childrens.length - minorChildren.length - youngAdults.length} majeur(s)</p>
                    </div>
                </div>
                <div className="flex-row align-items-center">
                    <img className="img-fluid mr-3 h-4" src={homechildren} alt="handicapée" />
                    <div className="my-auto">
                        <p className="h6 text-uppercase font-weight-bold my-auto o-40">handicapée(s)</p>
                        <p className="h6 text-uppercase font-weight-bold my-auto">{handicapedChildren.length} personne(s)</p>
                    </div>
                </div>
            </div>
            <ModalFamilyEnv  deathDeclaration={deathDeclaration} userId={userId} isLoading={isLoading} />
        </section>
    )
}